var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNbWifiTablet(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 38 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EF8E0BA7-CE3D-4646-A380-620C86333C3C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-wifi-access-create1",
    transform: "translate(-301.000000, -423.000000)",
    fill: "#76778C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.864919,423.257043 C303.469524,423.257043 301.497984,425.204005 301.497984,427.569543 L301.497984,464.301451 C301.497984,466.667001 303.469524,468.613951 305.864919,468.613951 L334.077621,468.613951 C336.473016,468.613951 338.444556,466.667001 338.444556,464.301451 L338.444556,427.569543 C338.444556,425.204005 336.473016,423.257043 334.077621,423.257043 L305.864919,423.257043 Z M305.864919,425.678096 L334.077621,425.678096 C335.157229,425.678096 335.992944,426.50339 335.992944,427.569543 L335.992944,464.301451 C335.992944,465.367622 335.157229,466.192898 334.077621,466.192898 L305.864919,466.192898 C304.785312,466.192898 303.949597,465.367622 303.949597,464.301451 L303.949597,427.569543 C303.949597,426.50339 304.785312,425.678096 305.864919,425.678096 Z M306.726815,427.607372 C306.095088,427.666168 305.613191,428.191288 305.615916,428.817898 L305.615916,459.724148 C305.615916,460.392676 306.164768,460.934675 306.841734,460.934675 L333.100806,460.934675 C333.777773,460.934675 334.326613,460.392676 334.326613,459.724148 L334.326613,428.817898 C334.326613,428.149371 333.777773,427.607439 333.100806,427.607372 L306.841734,427.607372 C306.803448,427.605598 306.7651,427.605598 306.726815,427.607372 Z M308.06754,430.028425 L331.875,430.028425 L331.875,458.513622 L308.06754,458.513622 L308.06754,430.028425 Z M319.980847,462.088458 C319.114982,462.088458 318.410282,462.792775 318.410282,463.639444 C318.410282,464.486114 319.114982,465.171517 319.980847,465.171517 C320.846711,465.171517 321.551411,464.486114 321.551411,463.639444 C321.551411,462.792775 320.846711,462.088458 319.980847,462.088458 Z",
    id: "nb_wifi_tablet"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbWifiTablet);
export default __webpack_public_path__ + "static/media/nb-wifi-tablet.59054d2c13e6bec93b9dede23a54b7db.svg";
export { ForwardRef as ReactComponent };